module.exports = __webpack_public_path__ + "static/media/account-group.943d6391.png";